export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://wireoxapi.erp.gold/api";

export const API_HEADERS = {
  Token:
    process.env.REACT_APP_API_TOKEN || "cb030399-6777-4b50-957f-31ce3ee4c5ff",
  UserName: process.env.REACT_APP_API_USERNAME || "production@wireox.com",
  Cookie: process.env.REACT_APP_API_COOKIE || "ASP.NET_SessionId=1xsvbpyq1wg4ymh3ihdtz243",
};
